import { QuestionarioBateriaModel } from "@/models/cadastros/assistencia/bateria/QuestionarioBateriaModel";
import { LocalizacaoDTO } from "@/api/assistencia24h/LocalizacaoDTO";
import { EnderecoDTO } from "@/api/assistencia24h/EnderecoDTO";
import { ContatoDTO } from "@/api/assistencia24h/ContatoDTO";
import { VeiculoDTO } from "@/api/assistencia24h/VeiculoDTO";
import { obtemNumero, obtemDDD } from "@/views/util/util";
import { QuestionarioChaveiroModel } from "@/models/cadastros/assistencia/chaveiro/QuestionarioChaveiroModel";
import { SolicitacaoServicoDTO } from "@/api/assistencia24h/SolicitacaoServicoDTO";
import { QuestionarioTrocaPneuModel } from "@/models/cadastros/assistencia/troca_pneu/QuestionarioTrocaPneuModel";
import LocalidadeModel from "@/models/cadastros/assistencia/geolocalizacao/LocalidadeModel";
import { VeiculoModel } from "@/models/cadastros/assistencia/veiculo/VeiculoModel";
import { QuestionarioGuinchoModel } from "@/models/cadastros/assistencia/guincho/QuestionarioGuinchoModel";
import { QuestionarioTransporteAssociadoModel } from "@/models/cadastros/assistencia/transporteAssociado/QuestionarioTransporteAssociadoModel";
import { TransportePessoasDTO } from "@/api/assistencia24h/TransportePessoasDTO";
import { FotoDTO } from "@/api/assistencia24h/FotoDTO";
import ServicoSubClienteModel from "@/models/cadastros/assistencia/ServicoSubClienteModel";
import { ServicoSubClienteDTO } from "@/api/assistencia24h/ServicoSubClienteDTO";
import ClienteAdministrativoModel from "@/models/cadastros/assistencia/ClienteAdministrativoModel";
import { ClienteAdministrativoDTO } from "@/api/assistencia24h/ClienteAdministrativoDTO";
import { EnderecoAdministrativoDTO } from "@/api/assistencia24h/EnderecoAdministrativoDTO";

function converteServicoSubClienteEmDTO(
  servicoSubClienteModel: ServicoSubClienteModel
): ServicoSubClienteDTO {
  const servicoSubClienteDTO = new ServicoSubClienteDTO(
    servicoSubClienteModel.nomeSubCliente,
    servicoSubClienteModel.cpfCnpj?.replace(/\D/g, ""),
    servicoSubClienteModel.email,
    servicoSubClienteModel.telefone,
    servicoSubClienteModel.cep,
    servicoSubClienteModel.tipoEndereco?.valor,
    servicoSubClienteModel.logradouro,
    servicoSubClienteModel.numero,
    servicoSubClienteModel.complemento,
    servicoSubClienteModel.bairro,
    servicoSubClienteModel.cidade,
    servicoSubClienteModel.estado?.sigla,
  );
  return servicoSubClienteDTO;
}

function converteClienteAdministrativoEmDTO(
  clienteAdministrativoModel: ClienteAdministrativoModel
): ClienteAdministrativoDTO {
  const enderecoClienteAdministratio = new EnderecoAdministrativoDTO(
    clienteAdministrativoModel.endereco?.cep,
    clienteAdministrativoModel.endereco?.logradouro,
    clienteAdministrativoModel.endereco?.bairro,
    clienteAdministrativoModel.endereco?.cidade,
    clienteAdministrativoModel.endereco?.estado?.sigla,
    clienteAdministrativoModel.endereco?.tipoEndereco?.valor,
    clienteAdministrativoModel.endereco?.numero,
    clienteAdministrativoModel.endereco?.complemento
  );

  const clienteAdministrativoDTO = new ClienteAdministrativoDTO(
    clienteAdministrativoModel.id || 0,
    clienteAdministrativoModel.nome,
    clienteAdministrativoModel.cpfCnpj?.replace(/\D/g, ""),
    clienteAdministrativoModel.frota,
    clienteAdministrativoModel.email,
    clienteAdministrativoModel.telefone?.replace(/\D/g, ''),
    enderecoClienteAdministratio
  );
  return clienteAdministrativoDTO;
}

function converteLocalizacaoModelEmDTO(
  localizacaoModel: LocalidadeModel
): LocalizacaoDTO {
  if (localizacaoModel.latitude && localizacaoModel.longitude && (localizacaoModel.cep == undefined || localizacaoModel.cep == "")) {
    const enderecoZerado = new EnderecoDTO(
      "",
      "",
      "",
      "",
      "PA",
      "",
      "",
    );

    const localizacaoDTO = new LocalizacaoDTO(
      enderecoZerado,
      localizacaoModel.latitude,
      localizacaoModel.longitude,
      localizacaoModel.nomeResponsavel,
      localizacaoModel.telefoneResponsavel
    );
    return localizacaoDTO;
  } else {
    const endereco = new EnderecoDTO(
      localizacaoModel.cep || "",
      localizacaoModel.logradouro,
      localizacaoModel.bairro,
      localizacaoModel.cidade,
      `${localizacaoModel.estado?.sigla || ""}`,
      localizacaoModel.numero,
      localizacaoModel.complemento
    );
    
    const localizacaoDTO = new LocalizacaoDTO(
      endereco,
      localizacaoModel.geoPosicao?.latitude,
      localizacaoModel.geoPosicao?.longitude,
      localizacaoModel.nomeResponsavel,
      localizacaoModel.telefoneResponsavel
    );
    return localizacaoDTO;
  }
  
}

function converteVeiculoModelEmDTO(veiculoModel: VeiculoModel): VeiculoDTO {
  const veiculo = new VeiculoDTO(
    veiculoModel.anoFabricacao,
    veiculoModel.cor,
    veiculoModel.marca,
    veiculoModel.modelo,
    veiculoModel.placa,
    veiculoModel.tipoVeiculo?.valor || "LEVE",
    false
  );
  return veiculo;
}

export function converterBateriaModelEmDTO(
  questionarioBateriaModel: QuestionarioBateriaModel
): SolicitacaoServicoDTO {
  const localizacaoOrigem = converteLocalizacaoModelEmDTO(
    questionarioBateriaModel.localizacao
  );

  const veiculo = converteVeiculoModelEmDTO(questionarioBateriaModel.veiculo);
  veiculo.pertenceAoAssociado =
    questionarioBateriaModel.veiculoPertenceAoAssociado;

  let contato;
  // if (questionarioBateriaModel.veiculoPertenceAoAssociado === false) {
    contato = new ContatoDTO(
      questionarioBateriaModel.nomeContatoNoLocal || "",
      obtemDDD(questionarioBateriaModel.telefoneContatoNoLocal || ""),
      obtemNumero(questionarioBateriaModel.telefoneContatoNoLocal || "")
    );
  // }

  const servicoSubCliente = converteServicoSubClienteEmDTO(questionarioBateriaModel.servicoSubCliente!);
  const clienteAdministrativo = converteClienteAdministrativoEmDTO(questionarioBateriaModel.clienteAdministrativo!);
  
  return SolicitacaoServicoDTO.criarSolicitacaoBateria(
    questionarioBateriaModel.idServico,
    clienteAdministrativo.id || 0,
    localizacaoOrigem,
    veiculo,
    contato,
    servicoSubCliente,
    questionarioBateriaModel.veiculoEletrico,
    questionarioBateriaModel.amperagemVeiculo,
    clienteAdministrativo
  );
}

export function converterChaveiroModelEmDTO(
  questionarioChaveiroModel: QuestionarioChaveiroModel
): SolicitacaoServicoDTO {
  const localizacaoOrigem = converteLocalizacaoModelEmDTO(
    questionarioChaveiroModel.localizacao
  );

  const veiculo = converteVeiculoModelEmDTO(questionarioChaveiroModel.veiculo);
  veiculo.pertenceAoAssociado =
    questionarioChaveiroModel.veiculoPertenceAoAssociado; 
  veiculo.fotos =  questionarioChaveiroModel.fotosAcidente?.map((f) => new FotoDTO(f.UID)) ||
  ([] as FotoDTO[]);
  
  let contato;
  if (questionarioChaveiroModel.veiculoPertenceAoAssociado === false) {
    contato = new ContatoDTO(
      questionarioChaveiroModel.nomeContatoNoLocal || "",
      obtemDDD(questionarioChaveiroModel.telefoneContatoNoLocal || ""),
      obtemNumero(questionarioChaveiroModel.telefoneContatoNoLocal || "")
    );
  }

  const servicoSubCliente = converteServicoSubClienteEmDTO(questionarioChaveiroModel.servicoSubCliente!);
  const clienteAdministrativo = converteClienteAdministrativoEmDTO(questionarioChaveiroModel.clienteAdministrativo!);

  return SolicitacaoServicoDTO.criarSolicitacaoChaveiro(
    questionarioChaveiroModel.idServico,
    clienteAdministrativo.id || 0,
    localizacaoOrigem,
    veiculo,
    questionarioChaveiroModel.motivoSolicitacao.valorIntegracao,
    contato,
    servicoSubCliente,
    clienteAdministrativo
  );
}

export function converterTrocaPneuModelEmDTO(
  questionarioTrocaPneuModel: QuestionarioTrocaPneuModel
): SolicitacaoServicoDTO {
  const localizacaoOrigem = converteLocalizacaoModelEmDTO(
    questionarioTrocaPneuModel.localizacao
  );

  const veiculo = converteVeiculoModelEmDTO(questionarioTrocaPneuModel.veiculo);
  veiculo.pertenceAoAssociado =
    questionarioTrocaPneuModel.veiculoPertenceAoAssociado;
  veiculo.estaEmLocalFechado = questionarioTrocaPneuModel.veiculoEmLocalFechado;
  veiculo.estaNoSubsolo = questionarioTrocaPneuModel.veiculoEmSubsolo;

  let contato;
  if (questionarioTrocaPneuModel.veiculoPertenceAoAssociado === false) {
    contato = new ContatoDTO(
      questionarioTrocaPneuModel.nomeContatoNoLocal || "",
      obtemDDD(questionarioTrocaPneuModel.telefoneContatoNoLocal || ""),
      obtemNumero(questionarioTrocaPneuModel.telefoneContatoNoLocal || "")
    );
  }

  const servicoSubCliente = converteServicoSubClienteEmDTO(questionarioTrocaPneuModel.servicoSubCliente!);
  const clienteAdministrativo = converteClienteAdministrativoEmDTO(questionarioTrocaPneuModel.clienteAdministrativo!);
  return SolicitacaoServicoDTO.criarSolicitacaoTrocaPneu(
    questionarioTrocaPneuModel.idServico,
    clienteAdministrativo.id || 0,
    localizacaoOrigem,
    veiculo,
    contato,
    servicoSubCliente,
    questionarioTrocaPneuModel.possuiFerramenta,
    clienteAdministrativo
  );
}

export function converterGuinchoModelEmDTO(
  questionarioGuinchoModel: QuestionarioGuinchoModel
): SolicitacaoServicoDTO {
  const localizacaoOrigem = converteLocalizacaoModelEmDTO(
    questionarioGuinchoModel.localizacao
  );

  const veiculo = converteVeiculoModelEmDTO(questionarioGuinchoModel.veiculo);
  veiculo.pertenceAoAssociado =
    questionarioGuinchoModel.veiculoPertenceAoAssociado;
  veiculo.parteDanificada =
    questionarioGuinchoModel.parteDanificada?.valorIntegracao;
  veiculo.outraParteDanificada =
    questionarioGuinchoModel.descricaoParteDanificada;
  veiculo.algumaRodaTravada = questionarioGuinchoModel.rodaTravada;
  veiculo.fotos =
    questionarioGuinchoModel.fotos?.map((f) => new FotoDTO(f.UID)) ||
    ([] as FotoDTO[]);

  let contato;
  if (questionarioGuinchoModel.veiculoPertenceAoAssociado === false) {
    contato = new ContatoDTO(
      questionarioGuinchoModel.nomeContatoNoLocal || "",
      obtemDDD(questionarioGuinchoModel.telefoneContatoNoLocal || ""),
      obtemNumero(questionarioGuinchoModel.telefoneContatoNoLocal || "")
    );
  }

  const localizacaoDestino = converteLocalizacaoModelEmDTO(
    questionarioGuinchoModel.destino
  );
  
  
  const servicoSubCliente = converteServicoSubClienteEmDTO(questionarioGuinchoModel.servicoSubCliente!);

  const tipoLocalRemocao = questionarioGuinchoModel.tipoLocalRemocao?.valor;
  const liberadoRemocao = questionarioGuinchoModel.liberadoRemocao
  const rodaTravada =  questionarioGuinchoModel.rodaTravada;
  const veiculoEletrico =  questionarioGuinchoModel.veiculoEletrico;
  const veiculoBlindado =  questionarioGuinchoModel.veiculoBlindado;
  const veiculoCarregado =  questionarioGuinchoModel.veiculoCarregado;
  const idPrestador =  questionarioGuinchoModel.idPrestador;

  const clienteAdministrativo = converteClienteAdministrativoEmDTO(questionarioGuinchoModel.clienteAdministrativo!);
  
  return SolicitacaoServicoDTO.criarSolicitacaoGuincho(
    questionarioGuinchoModel.idServico,
    clienteAdministrativo.id || 0,
    localizacaoOrigem,
    localizacaoDestino,
    veiculo,
    questionarioGuinchoModel.associadoNoLocal || false,
    questionarioGuinchoModel.motivoSolicitacao.valorIntegracao,
    contato,
    servicoSubCliente,
    tipoLocalRemocao,
    liberadoRemocao,
    rodaTravada,
    veiculoEletrico,
    veiculoBlindado,
    veiculoCarregado,
    clienteAdministrativo,
    idPrestador
  );
}

export function converterTransporteAssociadoModelEmDTO(
  questionarioTransporteAssociadoModel: QuestionarioTransporteAssociadoModel
): SolicitacaoServicoDTO {
  const localizacaoOrigem = converteLocalizacaoModelEmDTO(
    questionarioTransporteAssociadoModel.enderecoSelecionado
  );

  let contato;

  contato = new ContatoDTO(
    questionarioTransporteAssociadoModel.nomeContatoLocal,
    obtemDDD(questionarioTransporteAssociadoModel.telefoneContatoLocal),
    obtemNumero(questionarioTransporteAssociadoModel.telefoneContatoLocal)
  );

  const localizacaoDestino = converteLocalizacaoModelEmDTO(
    questionarioTransporteAssociadoModel.destinoSelecionado
  );

  const transportePessoas = new TransportePessoasDTO(
    questionarioTransporteAssociadoModel.quantidadePessoas,
    questionarioTransporteAssociadoModel.possuiLimitacao,
    false,
    false,
    questionarioTransporteAssociadoModel.descricaoLimitacao,
    questionarioTransporteAssociadoModel.observacao
  );

  const servicoSubCliente = converteServicoSubClienteEmDTO(questionarioTransporteAssociadoModel.servicoSubCliente!);

  return SolicitacaoServicoDTO.criarSolicitacaoTransportePessoas(
    questionarioTransporteAssociadoModel.idServico,
    1220/*usuarioModule.idCliente*/,
    localizacaoOrigem,
    localizacaoDestino,
    questionarioTransporteAssociadoModel.nomeSolicitante,
    transportePessoas,
    contato,
    servicoSubCliente
  );
}
